import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../../components/global/Button';
import { isEligibleForShutterbugFreeTrial } from '../../../PhotoSearchCheckout/helpers';
import FeatureItem from '../FeatureItem/FeatureItem';
import { SHUTTERBUG_PROMO_FEATURES } from '../../helpers';

const propTypes = {
  className: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    search_subscription_free_trial_enabled: PropTypes.bool.isRequired,
  }),
};

const PhotoSearchCheckoutInterstitial = ({ className, onDismiss, account }) => {
  const classes = classNames({
    'photo-search-checkout-interstitial': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <h4 className="text-center mb-4">Waldo subscribers enjoy&hellip;</h4>

      <div className="photo-search-upsell-features">
        {SHUTTERBUG_PROMO_FEATURES.map(({ icon, title }) => (
          <FeatureItem icon={icon} title={title} />
        ))}
      </div>

      <Button
        btnStyle="yellow"
        className="photo-search-checkout-interstitial-btn mt-3 px-6"
        onClick={onDismiss}
      >
        {isEligibleForShutterbugFreeTrial(account)
          ? 'Start 30 Day Free Trial'
          : 'Become a Waldo Member'}
      </Button>
    </div>
  );
};

PhotoSearchCheckoutInterstitial.propTypes = propTypes;

export default PhotoSearchCheckoutInterstitial;
